import { PER_PAGE } from "./FunctionalUtils";

export enum AddUserActionDispatchTypes {
  POST_ADD_USER_SUCCESS = "POST_ADD_USER_SUCCESS",
  POST_ADD_USER_ERROR = "POST_ADD_USER_ERROR",
  POST_ADD_USER_INVOKE = "POST_ADD_USER_INVOKE",
  POST_ADD_USER_RESET = "POST_ADD_USER_RESET",
}
export const searchListPayload = {
  userId: "",
  firstName: "",
  isRoleType: "",
  lastName: "",
  email: "",
  agency: "",
  npiId: null,
  contains: true,
  pageNo: 1,
  pageSize: PER_PAGE,
  sortColumn: "lastName",
  sortOrder: "ASC",
};

export const searchAdminAccessListPayload = {
  npiId: "",
  agencyName: "",
  city: "",
  state: "",
  zipCode: "",
  pageNo: 1,
  pageSize: 20,
  sortColumn: "",
  sortOrder: "ASC",
  excludeExpired: false,
};

export const searchNotificationListPayload = {
  searchBy: "",
  searchValue: "",
  filterBy: "",
  sortColumn: "",
  sortOrder: "ASC",
  pageNo: 1,
  pageSize: 20,
};

export enum AddPortalUpdateActionDispatchTypes {
  POST_ADD_PORTAL_UPDATE_SUCCESS = "POST_ADD_PORTAL_UPDATE_SUCCESS",
  POST_ADD_PORTAL_UPDATE_ERROR = "POST_ADD_PORTAL_UPDATE_ERROR",
  POST_ADD_PORTAL_UPDATE_INVOKE = "POST_ADD_PORTAL_UPDATE_INVOKE",
}

export enum GetPortalUpdateActionDispatchTypes {
  GET_PORTAL_UPDATE_SUCCESS = "GET_PORTAL_UPDATE_SUCCESS",
  GET_PORTAL_UPDATE_ERROR = "GET_PORTAL_UPDATE_ERROR",
  GET_PORTAL_UPDATE_INVOKE = "GET_PORTAL_UPDATE_INVOKE",
}

export const maxLength = 250;
